// extracted by mini-css-extract-plugin
export default {"root":"ppRzN","tablet":"tQfCj","mobile":"tGqRQ","smallMobile":"rb2Pr","icon":"WxJnH"};